/*
 * @Author: your name
 * @Date: 2021-12-10 17:25:13
 * @LastEditTime: 2022-02-12 14:59:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \dhr_frontend\src\routes\modules\employeeContract.js
 */
export default [
    {
        name: 'laborContract',
        path: '/employeeContract/laborContract',
        component: () => import('@/views/employeeContract/laborContract/index.vue'),
        meta: {
            title: '劳动合同'
        }
    },
    {
        name: 'otherAgreements',
        path: '/employeeContract/otherAgreements',
        component: () => import('@/views/employeeContract/otherAgreements/index.vue'),
        meta: {
            title: '其他协议'
        },
    },
    {
        name: 'templateConfiguration',
        path: '/employeeContract/templateConfiguration',
        component: () => import('@/views/employeeContract/templateConfiguration/list.vue'),
        meta: {
            title: '模板配置'
        }
    },
    {
        name: 'onJobProve',
        path: '/employeeContract/onJobProve',
        component: () => import('@/views/employeeContract/onJobProve/index.vue'),
        meta: {
            title: '在职证明'
        }
    },
    {
        name: 'quitProve',
        path: '/employeeContract/quitProve',
        component: () => import('@/views/employeeContract/quitProve/index.vue'),
        meta: {
            title: '离职证明'
        }
    },
    {
        name: 'incomeProve',
        path: '/employeeContract/incomeProve',
        component: () => import('@/views/employeeContract/incomeProve/index.vue'),
        meta: {
            title: '收入证明'
        }
    }
]
